import { render, staticRenderFns } from "./ReclamationListPage.vue?vue&type=template&id=464702d2&"
import script from "./ReclamationListPage.vue?vue&type=script&lang=js&"
export * from "./ReclamationListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports